<main [class.standalone]="isStandalone()">
  @if (isStandalone()) {
    <span class="logout">
      <rcp-text-link-action (click)="logout()">
        {{ 'qz-log-out-zm' | translate }}
      </rcp-text-link-action>
    </span>
  } @else {
    <!-- Navs -->
    <rcp-top-nav logoUrl="/assets/img/logos/logo_workspace.svg" [showApplicationName]="false" />
    <rcp-side-nav />
  }

  <!-- Content -->
  <div class="main-outlet-container">
    <router-outlet />
  </div>
</main>

<rcp-modal-container />
<rcp-tour-container />
<rcp-file-preview />
<rcp-toast-notifications />
